import { render, staticRenderFns } from "./modal-task-attachments.vue?vue&type=template&id=126148ba&scoped=true&"
import script from "./modal-task-attachments.vue?vue&type=script&lang=ts&"
export * from "./modal-task-attachments.vue?vue&type=script&lang=ts&"
import style0 from "./modal-task-attachments.vue?vue&type=style&index=0&id=126148ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "126148ba",
  null
  
)

export default component.exports